var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { ProgressBar } from "../ProgressBar";
// styles
import "./progressIndicator.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-progressIndicator",
    valueToShow: false,
};
const ProgressIndicator = (_a) => {
    var { className, steps, currentStep, valueProgressBar, valueToShow } = _a, rest = __rest(_a, ["className", "steps", "currentStep", "valueProgressBar", "valueToShow"]);
    const classList = classNames("tecma-progressIndicator", className);
    const progressBarValue = (step) => {
        if (step === currentStep) {
            return valueProgressBar;
        }
        if (step < currentStep) {
            return 100;
        }
        return 0;
    };
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [valueToShow && (_jsxs("p", { className: "value", children: [currentStep, " / ", steps] })), Array.from(Array(steps).keys()).map((index) => {
                const step = index + 1;
                return (_jsx("div", { className: `stepProgressBar ${step === currentStep ? "currentStep" : ""}`, children: _jsx(ProgressBar, { value: progressBarValue(step) }) }, step));
            })] })));
};
ProgressIndicator.defaultProps = defaultProps;
export default React.memo(ProgressIndicator);
